module.exports = __webpack_public_path__ + "static/5-c891d4f6c2253c3285ce4fccf168614e.jpg";